import { apiSlice } from "../../api/ApiService";

const updateMilestoneTaskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateMilestoneTask: builder.mutation({
      query: ({ body, accessToken }) => ({
        url: `/api/v1/Administration/milestone`,
        method: "PUT",
        data: body,
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: [{ type: 'MilestoneTask' }],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateMilestoneTaskMutation } = updateMilestoneTaskApi;
export default updateMilestoneTaskApi;
